import { showClaim } from './claimAndAdd';

export type SearchRow = {
  id: string;
  reachable: boolean;
  assignedInspectorId: string | null;
};

/**
 * What a row of the staff-wide search offers (Jim 10/27): a site the inspector
 * already reaches opens and can be inspected; one outside their reach shows
 * Claim first, and opens once claimed.
 */
export function searchRowState(
  row: SearchRow,
  userId: string | undefined
): { canOpen: boolean; canClaim: boolean } {
  return {
    canOpen: row.reachable,
    canClaim: showClaim(row, userId),
  };
}
